// Redux Actions
import {
  SET_STATE_LOCK_PM,
  SET_ENABLE_PM,
  SET_SOCKET_PM,
  SET_SOCKET_CONNECT_PM,
  SET_STATE_SERVER_PM,
  SET_ROOMS_PM,
  SET_PLAYERS_IN_ROOM_PM,
  SET_WATCHER_PM,
  SET_OUTSIDER_PM,
  SET_TRACKER_PM,
  SET_IN_ROOM_PM,
  SET_NAME_IN_ROOM_PM,
  SET_VISIBLE_CHAT_PM,
  TOGGLE_VISIBLE_CHAT_PM,
  SET_MESSAGES_PM,
  ADD_MESSAGE_PM,
  SET_REQUEST_PM,
  EMIT_SHARED_PLAYLIST_PM,
  EMIT_SUGGESTED_PLAYLIST_PM,
  SET_PERMISSION_STATE_PLAYER_PM,
  BROADCAST_PLAYER_MESSAGE_PM,
  BROADCAST_AUDIO_PM,
  SET_AUDIO_INFOS_PM,
  SET_DEV_PM,
  BROADCAST_CURSOR_FROM_ACTION_PM,
  SET_QUEUES_DJ_PM,
  SET_RESPONSE_TO_DJ_PM,
  SET_SHOW_AUDIO,
  REFRESH_PUBLIC_SESSIONS
} from "../types";

export function setStateLockPM(payload) {
  return { type: SET_STATE_LOCK_PM, payload }
};

export function setEnablePM(payload) {
  return { type: SET_ENABLE_PM, payload }
};

export function setSocketPM(payload) {
  return { type: SET_SOCKET_PM, payload }
};

export function setSocketConnectPM(payload) {
  return { type: SET_SOCKET_CONNECT_PM, payload }
};

export function setStateServerPM(payload) {
  return { type: SET_STATE_SERVER_PM, payload }
};

export function setRoomsPM(payload) {
  return { type: SET_ROOMS_PM, payload }
};

export function setPlayersInRoomPM(payload) {
  return { type: SET_PLAYERS_IN_ROOM_PM, payload }
};

export function setWatcherPM(payload) {
  return { type: SET_WATCHER_PM, payload }
};

export function setOutsiderPM(payload) {
  return { type: SET_OUTSIDER_PM, payload }
};

export function setTrackerPM(payload) {
  return { type: SET_TRACKER_PM, payload }
};

export function setInRoomPM(payload) {
  return { type: SET_IN_ROOM_PM, payload }
};

export function setNameInRoomPM(payload) {
  return { type: SET_NAME_IN_ROOM_PM, payload }
};

export function setChatPM(payload) {
  return { type: SET_VISIBLE_CHAT_PM, payload }
};

export function toggleChatPM() {
  return { type: TOGGLE_VISIBLE_CHAT_PM }
};

export function setMessagesPM(payload) {
  return { type: SET_MESSAGES_PM, payload }
};

export function addMessagePM(payload) {
  return { type: ADD_MESSAGE_PM, payload }
};

export function setRequestPM(payload) {
  return { type: SET_REQUEST_PM, payload }
};

export function emitSharedPlaylistPM(payload) {
  return { type: EMIT_SHARED_PLAYLIST_PM, payload }
};

export function emitSuggestedPlaylistPM(payload) {
  return { type: EMIT_SUGGESTED_PLAYLIST_PM, payload }
};

export function setPermissionStatePlayerPM(payload) {
  return { type: SET_PERMISSION_STATE_PLAYER_PM, payload }
};

export function broadcastAudioPM(payload) {
  return { type: BROADCAST_AUDIO_PM, payload }
};

export function setAudioInfosPM(payload) {
  return { type: SET_AUDIO_INFOS_PM, payload }
};

export function broadcastPlayerMessagePM(payload) {
  return { type: BROADCAST_PLAYER_MESSAGE_PM, payload }
};

export function setDevPM(payload) {
  return { type: SET_DEV_PM, payload }
};

export function broadcastCursorFromActionPM(payload) {
  return { type: BROADCAST_CURSOR_FROM_ACTION_PM, payload }
};

export function setQueuesDJ(payload) {
  return { type: SET_QUEUES_DJ_PM, payload }
};

export function setResponseToDJ(payload) {
  return { type: SET_RESPONSE_TO_DJ_PM, payload }
};

export function setShowAudio(payload) {
  return { type: SET_SHOW_AUDIO, payload }
};

export function refreshPublicSessions(payload) {
  return { type: REFRESH_PUBLIC_SESSIONS, payload }
};
